export const homeFaqItems = [
  {
    question: "What is NimbalkarVadhuVar.com Vadhu Var Search?",
    answer:
      "NimbalkarVadhuVar.com Vadhu Var Search is an online brand of 'Marathi Vadhu Var Suchak', which displays well educated Maratha Vadhu Var list on one click. It's simply a free online classified of 'Marathi Vadhu Var Suchak'.",
  },
  {
    question: "What are the benefits of NimbalkarVadhuVar.com Vadhu Var Search?",
    answer:
      "Well educated Maratha Vadhu Var can search and view verified profiles on just a single click with a photo.",
  },
  {
    question: "How could I add my profile on NimbalkarVadhuVar.com Vadhu Var Search list?",
    answer:
      "It's very easy, just register free on the parent site 'MarathiVadhuVarSuchak.com'. And your profile will be displayed on NimbalkarVadhuVar.com list too.",
  },
  {
    question:
      "How could I see the full profile viewed on NimbalkarVadhuVar.com Vadhu Var search?",
    answer:
      "First register free on parent site 'MarathiVadhuVarSuchak.com' and then you can see the full profile, which was viewed on NimbalkarVadhuVar.com Vadhu Var search result.",
  },
  {
    question: "Can I use NimbalkarVadhuVar.com Vadhu Var search for free?",
    answer:
      "Yes! NimbalkarVadhuVar.com Vadhu Var search is free. However, its parent site 'MarathiVadhuVarSuchak.com' also allowed free online registration.",
  },
] as const;
